function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent, Fragment } from "react";
import { componentStyles } from "./select-input.scss";
import { commonInputStyles } from "../common-inputs.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import classnames from "classnames";
class SelectInput extends PureComponent {
    render() {
        const { inputData, errorState, onInputChange, onInputBlur, value, invalid, errorLabelId, id } = this.props;
        const { inputName, isRequired, options, defaultValue } = inputData;
        const { isValid } = errorState;
        const showRequiredError = !isValid && isRequired;
        const requiredClass = {
            "input-required": showRequiredError
        };
        return /*#__PURE__*/ _jsxs(Fragment, {
            children: [
                /*#__PURE__*/ _jsx("select", {
                    id: id,
                    onChange: onInputChange,
                    onBlur: onInputBlur,
                    name: inputName,
                    value: value || defaultValue,
                    "aria-required": isRequired,
                    "aria-invalid": invalid,
                    "aria-describedby": errorLabelId,
                    className: `jsx-${componentStyles.__hash} jsx-${commonInputStyles.__hash}` + " " + (classnames("hp-input hp-select-input", requiredClass, {
                        "is-placholder": !value
                    }) || ""),
                    children: this.renderOptions(options, defaultValue)
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: commonInputStyles.__hash,
                    children: commonInputStyles
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "renderOptions", (options, defaultValue)=>{
            const { translate } = this.props;
            const optionsToRender = options.map((option)=>/*#__PURE__*/ _jsx("option", {
                    className: "contact-form-row",
                    value: option,
                    name: option,
                    children: translate(option)
                }, option));
            return /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    defaultValue && /*#__PURE__*/ _jsx("option", {
                        disabled: true,
                        value: defaultValue,
                        children: translate(defaultValue)
                    }),
                    optionsToRender
                ]
            });
        });
    }
}
SelectInput.defaultProps = {
    invalid: false,
    errorLabelId: null
};
export default withGenericConfig(SelectInput);
